export default __webpack_public_path__ + "static/media/provider-goal-growth.aaa56481.png";